import { render, staticRenderFns } from "./AdminSuperBonoView.vue?vue&type=template&id=177119b6&"
import script from "./AdminSuperBonoView.vue?vue&type=script&lang=js&"
export * from "./AdminSuperBonoView.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuperBonoView.vue?vue&type=style&index=0&id=177119b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports